import { Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ZielgruppeEPZ: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Zielgruppe' description={PLATZHALTER_TEXT} />
			<InhaltWrapper marginTop='0'>
				<Typography>
					Welche Personengruppe soll mit dem Projekt unmittelbar (z.B. Lehrkräfte) und mittelbar (z.B. Schülerinnen und Schüler) erreicht werden?
					Wirken die Begünstigten an den Maßnahmen selbst mit? Wie viele Personen sollen erreicht werden?
				</Typography>
			</InhaltWrapper>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default ZielgruppeEPZ;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Zielgruppe, maxCharLength: 2000 }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucZielgruppeEPZ = (_application: any) => {
	return concat(formStruc());
};
